<div class="content">
    <div class="content-header p-d-flex p-jc-between p-ai-center">
        <div class="title">
            <h1>Creación de configuración de presorteo</h1>
            <p>Espacio para crear una configuración de presorteo</p>
        </div>
        <div class="button">
            <p-button label="Regresar" icon="pi pi-angle-left" (click)="goBack()"></p-button>
        </div>
    </div>
    <div class="content-body">
        <div class="card p-mt-3">
            <app-config-presorteo-edit></app-config-presorteo-edit>
        </div>
    </div>
</div>
